import keyBy from 'lodash/keyBy';
import map from 'lodash/map';

import { EmailBatchesState, GlobalAction } from '.';

const GET_EMAIL_BATCHES_START = 'GET_EMAIL_BATCHES_START';
const GET_EMAIL_BATCHES_ERROR = 'GET_EMAIL_BATCHES_ERROR';
const GET_EMAIL_BATCHES_SUCCESS = 'GET_EMAIL_BATCHES_SUCCESS';
const RESEND_EMAIL_BATCHES_START = 'RESEND_EMAIL_BATCHES_START';
const RESEND_EMAIL_BATCHES_SUCCESS = 'RESEND_EMAIL_BATCHES_SUCCESS';
const RESEND_EMAIL_BATCHES_ERROR = 'RESEND_EMAIL_BATCHES_ERROR';

export const emailBatchesReducer = (
  state: EmailBatchesState,
  action: GlobalAction
): EmailBatchesState => {
  const { payload, type } = action;
  switch (type) {
    case GET_EMAIL_BATCHES_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_EMAIL_BATCHES_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_EMAIL_BATCHES_SUCCESS: {
      return {
        ...state,
        emailBatches: keyBy(payload.emailBatches, 'batchId'),
        order: map(payload.emailBatches, 'batchId'),
        page: payload.page,
        size: payload.size,
        count: payload.count,
        sort: payload.sort,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const EMAIL_BATCHES_ACTIONS = {
  GET_EMAIL_BATCHES_START,
  GET_EMAIL_BATCHES_ERROR,
  GET_EMAIL_BATCHES_SUCCESS,
  RESEND_EMAIL_BATCHES_START,
  RESEND_EMAIL_BATCHES_SUCCESS,
  RESEND_EMAIL_BATCHES_ERROR,
};
